import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function stationChecked({
    action,
    arriveStationCount = 0,
    departStationCount = 0,
    direction,
    searchParams = {},
    selectedStations,
    selectedStationsBefore,
    totalTrips,
    unSelectedStations,
}) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    const property = {
        num_trips: totalTrips,
        selected_stations: selectedStations,
        unselected_stations: unSelectedStations,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: `stations_${direction}`,
        property,
    });

    if (action === 'reset') {
        amplitude.track('Search Filter Removed', {
            arrive_address: destinationText,
            arrive_place_id: destinationPlaceId,
            arrive_station_count: arriveStationCount,
            depart_address: originText,
            depart_place_id: originPlaceId,
            depart_station_count: departStationCount,
            filter_type: `${direction}_stations`,
            ui_source: 'sidebar_filter',
        });
    } else {
        amplitude.track('Search Filtered', {
            arrive_address: destinationText,
            arrive_place_id: destinationPlaceId,
            arrive_station_count: arriveStationCount,
            depart_address: originText,
            depart_place_id: originPlaceId,
            depart_station_count: departStationCount,
            filter_list_selected_count: selectedStations.length,
            filter_list_total_count: selectedStations.length + unSelectedStations.length,
            filter_type: `${direction}_stations`,
            results_count_before: totalTrips,
            ui_source: 'sidebar_filter',
            updated_from: selectedStationsBefore,
            updated_to: selectedStations,
        });
    }
}

function moreButtonClicked(action) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_search',
        label: `stations_${action}`,
    });
}

export default {
    moreButtonClicked,
    stationChecked,
};
